import { useCookies } from 'react-cookie'

const getExpiryDateByDay = (days = 0) => {
  const date = new Date()
  const newDate = date.setDate(date.getDate() + days)
  return new Date(newDate)
}

const isCookieSet = (cookieName = '', value = '') => {
  const [cookies] = useCookies([cookieName])
  const isCookieSet = cookies[cookieName] && cookies[cookieName] === value

  if (isCookieSet === undefined || !isCookieSet) return false

  return true
}

export { isCookieSet, getExpiryDateByDay }
